import React from "react"

import * as styles from "./swipe.module.scss"
import ArrowSwipe from "../../../assets/images/icons/arrow-swipe.svg"
import { useIntl } from "gatsby-plugin-intl"


const Swipe = () => {
	const intl = useIntl()
	return (
		<div className={styles.swipe}>
			<img src={ArrowSwipe} alt="Arrow left" width={15} height={12} />
			<span>{intl.formatMessage({ id: "index.swipe" })}</span>
			<img className={styles.swipeRight} src={ArrowSwipe} alt="Arrow left" width={15} height={12} />

		</div>
	);
}

export default Swipe;